export const GET_DOCUMENTS = 'GET_DOCUMENTS'
export const SET_DOCUMENTS = 'SET_DOCUMENTS'
export const GET_DOCUMENTS_ERROR = 'GET_DOCUMENTS_ERROR'
export const RESET_DOCUMENTS = 'RESET_DOCUMENTS'
